import React from "react";
// import { Link } from "react-router-dom";
import cn from "classnames";
import styles from "./Hero.module.sass";
import Image from "../../../components/Image";
import ScrollButton from "../../../components/ScrollButton";
// import ScrollParallax from "../../../components/ScrollParallax";

const Hero = ({ scrollToRef }) => {
  return (
    <div className={styles.hero}>
      <div className={cn("container", styles.container)}>
        <div className={styles.wrap}>
          <div className={cn("stage", styles.stage)}>
            Snag deals. Save money. Save the planet.
          </div>
          <h1 className={cn("h1", styles.title)}>
            Restaurants waste about 33 billion lbs. of food every year
          </h1>
          <div className={styles.text}>
            In order to get ready for busy periods, restaurants must prep and cook a lot 
            of food ahead of time. But if it turns out to be a slow day, food is inevitably wasted! 
            But when restaurants offer real-time deals on Reffo, they can sell that food at a discount
            instead of throwing it away.
          </div>
          {/* <Link className={cn("button", styles.button)} to="/class02-details">
            Book a class
          </Link> */}
        </div>
        <ScrollButton
          onScroll={() =>
            scrollToRef.current.scrollIntoView({ behavior: "smooth" })
          }
          className={styles.scroll}
        />
        <div className={styles.gallery}>
          <div className={styles.preview}>
            <Image
              srcSet="/images/content/happyPlanet.png 2x"
              srcSetDark="/images/content/happyPlanet.png 2x"
              src="/images/content/happyPlanet.png"
              srcDark="/images/content/happyPlanet.png"
              alt="Main Pic"
            />
          </div>
          {/* <ScrollParallax
            className={styles.preview}
            animateIn="fadeInUp"
            delay={300}
          >
            <img
              srcSet="/images/content/ball@2x.png 2x"
              src="/images/content/ball.png"
              alt="Ball"
            />
          </ScrollParallax>
          <ScrollParallax
            className={styles.preview}
            animateIn="fadeInUp"
            delay={600}
          >
            <img
              srcSet="/images/content/ball-black@2x.png 2x"
              src="/images/content/ball-black.png"
              alt="Ball"
            />
          </ScrollParallax> */}
          
        </div>
      </div>
    </div>
  );
};

export default Hero;
